import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive, onMounted, ref, onUnmounted } from 'vue';
import headTabbar from './components/headTabbar';
import navigationbar from './components/navigationbar';

// 缩放比例，默认 1

export default {
  __name: 'App',
  setup(__props) {
    const scale = ref(1);
    const scaleVar = ref('scale(1)');

    // 配置（可自行修改）
    const config = {
      minScale: 0.5,
      // 最小缩放
      maxScale: 2.0,
      // 最大缩放
      step: 0.1 // 滚轮一次缩放多少
    };

    // 滚轮监听
    function handleWheel(e) {
      // 必须按住 Ctrl 才允许缩放
      if (!e.ctrlKey) return;
      e.preventDefault();

      // 向上滚 = 放大，向下滚 = 缩小
      if (e.deltaY < 0) {
        scale.value = Math.min(scale.value + config.step, config.maxScale);
      } else {
        scale.value = Math.max(scale.value - config.step, config.minScale);
      }
      scaleVar.value = `scale(${scale.value})`;
    }
    onMounted(() => {
      window.addEventListener('wheel', handleWheel, {
        passive: false
      });
    });
    onUnmounted(() => {
      window.removeEventListener('wheel', handleWheel);
    });
    const data = reactive({});
    onMounted(() => {// 代码逻辑0
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(headTabbar), {
        class: "headTab"
      }), _createVNode(_component_router_view), _createVNode(_unref(navigationbar), {
        class: "headTab"
      })], 64);
    };
  }
};